@if (loading) {
  <div class="spinner-container" (click)="$event.preventDefault();$event.stopPropagation()">
    <div class="spinner-border" role="status">
      <span class="sr-only">{{ 'ucs.loading' | translate }}</span>
    </div>
  </div>
}
